import { render, staticRenderFns } from "./ChemCard.vue?vue&type=template&id=e383a8bc&scoped=true"
import script from "./ChemCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChemCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChemCard.vue?vue&type=style&index=0&id=e383a8bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e383a8bc",
  null
  
)

export default component.exports